export const convertCurrency = async (from: string, to: string, amount = 1) => {
  const supportedCurrencies = [
    'AUD',
    'BGN',
    'BRL',
    'CAD',
    'CHF',
    'CNY',
    'CZK',
    'DKK',
    'EUR',
    'GBP',
    'HKD',
    'HUF',
    'IDR',
    'ILS',
    'INR',
    'ISK',
    'JPY',
    'KRW',
    'MXN',
    'MYR',
    'NOK',
    'NZD',
    'PHP',
    'PLN',
    'RON',
    'SEK',
    'SGD',
    'THB',
    'TRY',
    'USD',
    'ZAR',
  ];

  const upperFrom = from.toUpperCase();
  const upperTo = to.toUpperCase();

  try {
    if (
      supportedCurrencies.includes(upperFrom) &&
      supportedCurrencies.includes(upperTo)
    ) {
      const res = await fetch(
        `https://api.frankfurter.dev/v1/latest?from=${upperFrom}&to=${upperTo}`,
        { cache: 'no-store' },
      );

      if (!res.ok) throw new Error(`Frankfurter error: ${res.status}`);

      const data = await res.json();
      const rate = data?.rates?.[upperTo];
      return rate ? rate * amount : null;
    }

    const fallback = await fetch(
      `https://open.er-api.com/v6/latest/${upperFrom}`,
    );
    if (!fallback.ok) throw new Error(`Fallback API error: ${fallback.status}`);

    const data = await fallback.json();
    const rate = data?.rates?.[upperTo];
    return rate ? rate * amount : null;
  } catch (error) {
    console.error('Currency conversion failed:', error);
    return null;
  }
};
